/* eslint-disable max-len */
export const MuiButton = {
  styleOverrides: {
    root: {
      fontSize: '15px',
      fontWeight: '400',
      lineHeight: '26px',
      borderRadius: '8px',
      boxShadow: 'none',
      textTransform: 'none',
      padding: '17px 24px',

      '&:hover': {
        boxShadow: 'none',
      },
      '&.MuiButton-text': {
        padding: '8px 11px',
        fontSize: '15px',
        lineHeight: '26px',
      },
      '&.MuiButton-containedSecondary': {
        '& .MuiTouchRipple-ripple span': {
          background: 'var(--primary-shades-30-p-ripple)',
        },
      },
      '.MuiButton-startIcon': {
        zIndex: 1,
        svg: {
          fontSize: '24px',
        },
      },
      '.MuiButton-endIcon': {
        zIndex: 2,
        svg: {
          fontSize: '24px',
        },
      },
      '.MuiButton-contained': {
        padding: '17px 0',
        '& .MuiTouchRipple-ripple span': {
          background:
            'radial-gradient(rgba(255, 255, 255, 0.30) 99.54%, rgba(255, 255, 255, 0.00) 100%))',
        },
      },

      '&.Mui-disabled': {
        '.MuiButton-startIcon': {
          svg: {
            color: '#A6A6A6',
          },
        },
      },
    },
  },
}
